import React from "react";

export default function Placeholder({ title }: { title: string }) {
  return (
    <div className="placeholder-page">
      <h1>{title}</h1>
      <p className="meta">Próximamente.</p>
    </div>
  );
}
